import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

// Sentry — initialise early so errors during App render are captured.
// DSN empty in local dev → Sentry no-ops.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? 'unknown',
    release: process.env.REACT_APP_SENTRY_RELEASE,
    integrations: [
      Sentry.replayIntegration({
        // Replay free-tier: 50/month. Mask user input by default for privacy.
        maskAllText: false,
        blockAllMedia: true,
      }),
    ],
    // Performance tracing disabled (paid feature).
    tracesSampleRate: 0,
    // Capture session replays only on errors to stay within free-tier budget.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
